// src/modules/ai-agent/aiAgentService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

// Config
export const getConfig = async () => {
  const response = await axios.get(`${API_URL}/ai-agent/config`, getHeaders());
  return response.data;
};

export const updateConfig = async (config) => {
  const response = await axios.put(`${API_URL}/ai-agent/config`, config, getHeaders());
  return response.data;
};

// Voice
export const getVoiceConfig = async () => {
  const response = await axios.get(`${API_URL}/ai-agent/voice-config`, getHeaders());
  return response.data;
};

export const updateVoiceConfig = async (config) => {
  const response = await axios.put(`${API_URL}/ai-agent/voice-config`, config, getHeaders());
  return response.data;
};

// Prompt
export const getPrompt = async () => {
  const response = await axios.get(`${API_URL}/ai-agent/prompt`, getHeaders());
  return response.data;
};

export const updatePrompt = async (prompt) => {
  const response = await axios.put(`${API_URL}/ai-agent/prompt`, prompt, getHeaders());
  return response.data;
};

// Feature Flags
export const getFeatureFlags = async () => {
  const response = await axios.get(`${API_URL}/ai-agent/feature-flags`, getHeaders());
  return response.data;
};

export const updateFeatureFlags = async (flags) => {
  const response = await axios.put(`${API_URL}/ai-agent/feature-flags`, flags, getHeaders());
  return response.data;
};

// IVR Menu
export const getIvrMenu = async () => {
  const response = await axios.get(`${API_URL}/ai-agent/ivr-menu`, getHeaders());
  return response.data;
};

export const createIvrMenuOption = async (option) => {
  const response = await axios.post(`${API_URL}/ai-agent/ivr-menu`, option, getHeaders());
  return response.data;
};

export const updateIvrMenuOption = async (id, option) => {
  const response = await axios.put(`${API_URL}/ai-agent/ivr-menu/${id}`, option, getHeaders());
  return response.data;
};

export const deleteIvrMenuOption = async (id) => {
  const response = await axios.delete(`${API_URL}/ai-agent/ivr-menu/${id}`, getHeaders());
  return response.data;
};

export const reorderIvrMenu = async (items) => {
  const response = await axios.put(`${API_URL}/ai-agent/ivr-menu/reorder`, { items }, getHeaders());
  return response.data;
};

// Call Logs
export const getCallLogs = async (params = {}) => {
  const response = await axios.get(`${API_URL}/ai-agent/call-logs`, { ...getHeaders(), params });
  return response.data;
};

export const getCallLog = async (id) => {
  const response = await axios.get(`${API_URL}/ai-agent/call-logs/${id}`, getHeaders());
  return response.data;
};

export const getCallLogStats = async () => {
  const response = await axios.get(`${API_URL}/ai-agent/call-logs/stats`, getHeaders());
  return response.data;
};

// Service Areas
export const getServiceAreas = async () => {
  const response = await axios.get(`${API_URL}/ai-agent/service-areas`, getHeaders());
  return response.data;
};

export const createServiceArea = async (area) => {
  const response = await axios.post(`${API_URL}/ai-agent/service-areas`, area, getHeaders());
  return response.data;
};

export const updateServiceArea = async (id, area) => {
  const response = await axios.put(`${API_URL}/ai-agent/service-areas/${id}`, area, getHeaders());
  return response.data;
};

export const deleteServiceArea = async (id) => {
  const response = await axios.delete(`${API_URL}/ai-agent/service-areas/${id}`, getHeaders());
  return response.data;
};

export const checkServiceArea = async (zipcode) => {
  const response = await axios.get(`${API_URL}/ai-agent/service-areas/check`, { ...getHeaders(), params: { zipcode } });
  return response.data;
};
